import React, { useState } from "react";
import Loader from "../gif/loader.gif";
import Scan from "../gif/scan.gif";
import Check from "../gif/check.png";
import Logo from "../gif/logo.png";
import Barcode from "../gif/barcode.jpg";
import { Image } from "react-bootstrap";
function CardDesign({ cardUID, name, surname }) {
  return (
    <div className="d-flex justify-content-center align-items-center flex-column">
      <div
        className="mt-3 mb-3 p-3 d-flex align-items-center justify-content-between"
        style={{
          backgroundColor: "#E6F0FF",
          borderRadius: "15px",
          width: "20rem",
        }}
      >
        <span className="text-muted">
          Scan NFC Card or Tag on the white{" "}
          <span style={{ fontWeight: "bold", color: "#3b82f6" }}>
            NFC Reader
          </span>{" "}
          acs machine
        </span>
      </div>
      <div
        className="card d-flex justify-content-center align-items-center flex-column w-100 shadow p-3 bg-white"
        style={{
          height: "16rem",
          padding: "20px",
          borderRadius: 15,
        }}
      >
        <div className="row text-center">
          <Image
            className="mt-1"
            src={Logo} // replace with actual image url
            alt="Profile"
            style={{
              width: "170px",
              height: "150px",
            }}
          />
          <b
            style={{
              fontSize: "16pt",
              textTransform: "uppercase",
              position: "absolute",
              top: 0,
              left: 0,
              color: "lightgray",
            }}
          >
            Membership Card
          </b>
        </div>
        <div className="row text-center bg-success w-100">
          <h5 className="text-white">NEW TESTAMENT CHURCH - LS</h5>
        </div>
        <div className="row text-center w-100">
          <div className="col-md-6 text-start">
            <p>
              <small>Member Details</small>
            </p>
            <small>
              <b style={{ fontSize: "14pt" }}>
                {name} {surname}
              </b>
            </small>
          </div>
          <div className="col-md-6 text-end">
            <Image
              src={Barcode} // replace with actual image url
              alt="Profile"
              style={{
                width: "150px",
                height: "50px",
              }}
            />
            <p>
              <small
                style={{
                  letterSpacing: 11,
                  marginTop: "-5px",
                  textTransform: "uppercase",
                }}
              >
                {cardUID}
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CardDesign;
